import React from 'react';
 

function Header() {
 

  return (
     
          
    <nav className="d-nav">
        <a href="https://threesixtyeight.com/" className="d-nav_logo w-inline-block"
            ><img
                src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5efe014c0e6a5214acb516d6_logo.svg" alt=""
                className="d-nav_logo-img" /></a>
        <div className="d-nav_info">
            <div className="d-nav_song" ><img
                    src="https://assets.website-files.com/5efde90c257c12dbfe87c980/5f0631484a9644c084fbb0c4_art3.jpg"
                    alt="" className="d-nav_art" />
                <div className="d-nav_title" >
                    <h6 className="is--song" >DaDa</h6>
                    <p className="is--artist" >Ian Post</p>
                </div>
            </div>
            <div className="d-nav_time">
                <div className="d-nav_time-bar">
                    <div className="html-embed w-embed">
                        <div className="player-controls scrubber">
                            <span id="seek-obj-container">
                                <progress id="seek-obj" value="0.8379383890151837" max="1"
                                    ></progress>
                            </span>
                        </div>


                        
                    </div>
                </div>
                <div className="d-nav_time-text" >
                    <p id="start-time" className="is--text" >02:34</p>
                    <p className="is--text is--center" >/</p>
                    <p id="end-time" className="is--text" >03:04</p>
                </div>
            </div>
        </div>
        <div className="d-nav_spinning" >
            <p className="is--now-spin" >NOW<br/>SPINNING</p>
        </div>
    </nav>

              
  )   
}

export default Header;
